<template>
  <div class="home">
    <Menu></Menu>
    <div v-show="showList">
      <h2>ACSW Host Clubs</h2>
      <v-data-table
          :headers="headers"
          :items="clubs"
          :items-per-page="10"
          :search="search"
          sort-by="startDate"
          item-key="id"
          dense
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
                v-model="search"
                label="Search"
                class="mx-2"
            ></v-text-field>
            <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="newClub"
                v-show="mayCreate"
            >Add Host Club
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.clubName="{ item }">
          {{ item.clubName }}
        </template>
        <template v-slot:item.clubRep="{ item }">
          {{ item.clubRep }}
        </template>
        <template v-slot:item.webSite="{ item }">
          {{ item.webSite }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="clubClicked(item)"
          >
            mdi-file-document-outline
          </v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-show="showDetail">
      <ClubDetail :club="club" :hosts=hosts @endClubDetail="endClubDetail" @refreshClubs="refreshClubs"/>
    </div>
  </div>
</template>

<script>
import ClubDetail from '@/components/ClubDetail.vue'
import Menu from '@/components/Menu.vue'

export default {
  name: "Clubs",
  components: {
    ClubDetail,
    Menu,
  },
  data: () => ({
    showList: true,
    showDetail: false,
    disableAdd: true,
    clubs: [],
    club: {},
    hosts: [],
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'clubName'
      },
      {text: 'State', value: 'rep.state'},
      {text: 'Manager', value: 'rep.fullName'},
      {text: 'Web Site', value: 'webSite'},
      {text: 'Details', value: 'actions'},
    ]
  }),
  mounted: function () {
    console.log('Clubs mounted')
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadAll()
  },

  computed: {
    mayCreate: {
      get: function () {
        return this.$hasRole(['adm','sys', 'Host'])
      },
      set: function (newDate) {
        console.log(newDate)
        this.date = this.parseDate(newDate)
      }
    },
  },

  methods: {
    clubClicked: function (item) {
      this.club = item
      this.showList = !this.showList
      this.showDetail = !this.showDetail
    },
    loadAll: function () {
      this.loadClubs()
      this.loadHosts()
    },
    refreshClubs: function (uClub) {
      const cl_id = uClub.id
      for (let i=0; i< this.clubs.length; i++) {
        if (this.clubs[i].id == cl_id) {
          this.clubs[i].clubName = uClub.clubName
          this.clubs[i].id = uClub.id
          this.clubs[i].clubRep = uClub.clubRep
          this.clubs[i].webSite = uClub.webSite
          this.clubs[i].extra = Object.assign(this.clubs[i].extra ,uClub.extra)
          break
        }
      }
    },
    newClub: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      try {
        const resp = await this.$http.post(this.$remote + '/api.host/newhost', {
          token: theToken,
          clubrep: this.$usrStore.mNbr,
          clubname: '',
          website: null,
          extra: {}
        })
        const newClub = resp.data.club
        this.clubs.push(newClub)
        this.club=newClub
        this.showClub(newClub)
      } catch (e) {
        alert('Could not create new club. '+e)
      }
    },
    showClub: function (cl) {
      this.club = cl
      this.showList = false
      this.showDetail = true
    },
    endClubDetail: function () {
      this.showDetail = false
      this.showList = true
    },
    loadClubs: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.host/hosts', {
        token: theToken
      })
          .then(response => {
            console.log('Got response from hosts')
            this.clubs = response.data.hosts
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadHosts: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrwrole', {
        token: theToken,
        role: 'Host'
      })
          .then(response => {
            console.log('Got response from mbrwrole')
            this.hosts = response.data.mbrs
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    },
  }
}
</script>

<style scoped>

</style>